import { render, staticRenderFns } from "./userAgree.vue?vue&type=template&id=a65af392&scoped=true"
import script from "./userAgree.vue?vue&type=script&lang=js"
export * from "./userAgree.vue?vue&type=script&lang=js"
import style0 from "./userAgree.vue?vue&type=style&index=0&id=a65af392&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a65af392",
  null
  
)

export default component.exports